import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Players from "@/pages/Players";
import PlayerProfile from "@/pages/PlayerProfile";
import ClubsPartners from "@/pages/ClubsPartners";
import SubmitProfile from "@/pages/SubmitProfile";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import Contacts from "@/pages/Contacts";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-nos" element={<About />} />
            <Route path="/servicos" element={<Services />} />
            <Route path="/jogadores" element={<Players />} />
            <Route path="/jogadores/:slug" element={<PlayerProfile />} />
            <Route path="/clubes-parceiros" element={<ClubsPartners />} />
            <Route path="/submeter-perfil" element={<SubmitProfile />} />
            <Route path="/legacy-news" element={<News />} />
            <Route path="/legacy-news/:slug" element={<NewsArticle />} />
            <Route path="/contactos" element={<Contacts />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
